module.exports = __webpack_public_path__ + "static/media/menu-ios.8530234c.svg";